import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
export default React.forwardRef((props, ref) => {
    const settlements = React.useMemo(() => ([...props.records].sort((a, b) => a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()))), [props.records]);
    React.useImperativeHandle(ref, () => ({
        getContent: () => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(settlements[0] || '', 'text/html');
            const rows = Array.from(doc.querySelectorAll('tr')).slice(1);
            const records = rows.map((row) => Array.from(row.querySelectorAll('td')).map((cell) => (cell.textContent || '').trim()));
            return {
                headers: ['Batch Close Date', 'Close Time', 'Batch ID', 'Device ID', 'Batch Amount', 'Trans Count', 'Status'],
                records,
            };
        },
    }), [settlements]);
    return _jsx(_Fragment, { children: settlements.map((record, idx) => _jsx("div", { dangerouslySetInnerHTML: { '__html': record } }, idx)) });
});
